var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jitsiLocalStorage } from '@jitsi/js-utils';
import { updateSettings } from '../base/settings';
import { showWarningNotification } from '../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { isScreenAudioShared } from '../screen-share/functions';
import { setNoiseSuppressionEnabled, setNoiseSuppressionEnabledState } from './actions';
import i18next from 'i18next';
/**
 * Is noise suppression currently enabled.
 *
 * @param {IReduxState} state - The state of the application.
 * @returns {boolean}
 */
export function isNoiseSuppressionEnabled(state) {
    return state['features/noise-suppression'].enabled;
}
export function getNoiseSuppressionEnabledOnStartup(state) {
    var _a, _b;
    if (state && ((_a = state['features/base/conference']) === null || _a === void 0 ? void 0 : _a.conference)) {
        return isNoiseSuppressionEnabled(state);
    }
    return Boolean((_b = state['features/base/settings']) === null || _b === void 0 ? void 0 : _b.noiseSuppressionEnabledOnStartup);
}
/**
 * Verify if noise suppression can be enabled in the current state.
 *
 * @param {*} state - Redux state.
 * @param {*} dispatch - Redux dispatch.
 * @param {*} localAudio - Current local audio track.
 * @returns {boolean}
 */
export function canEnableNoiseSuppression(state, dispatch, localAudio) {
    const { channelCount } = localAudio.track.getSettings();
    const notificationTitle = i18next.t('notify.noiseSuppressionFailedTitle');
    const notificationDes = i18next.t('notify.noiseSuppressionDesktopAudioDescription');
    // Sharing screen audio implies an effect being applied to the local track, because currently we don't support
    // more then one effect at a time the user has to choose between sharing audio or having noise suppression active.
    if (isScreenAudioShared(state)) {
        dispatch(showWarningNotification({
            titleKey: notificationTitle,
            descriptionKey: notificationDes
        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        return false;
    }
    // Stereo audio tracks aren't currently supported, make sure the current local track is mono
    if (channelCount > 1) {
        dispatch(showWarningNotification({
            titleKey: notificationTitle,
            descriptionKey: notificationDes
        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        return false;
    }
    return true;
}
/**
 *  Sets the user's noise suppression setting.
 * @param enabled
 * @returns
 */
export function setNoiseSuppressionEnabledSetting(e) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const enabled = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.checked;
        const state = getState();
        if (state && ((_b = state['features/base/conference']) === null || _b === void 0 ? void 0 : _b.conference)) {
            yield dispatch(setNoiseSuppressionEnabled(enabled));
        }
        else {
            dispatch(setNoiseSuppressionEnabledState(enabled));
        }
        const isActuallyEnabled = isNoiseSuppressionEnabled(getState());
        jitsiLocalStorage.setItem('react/features/noise-suppression/enabled', isActuallyEnabled.toString());
        dispatch(updateSettings({ noiseSuppressionEnabledOnStartup: isActuallyEnabled }));
    });
}
